export const MINUTES = [
  { display: '0 minute', value: '0' },
  { display: '5 minutes', value: '5' },
  { display: '10 minutes', value: '10' },
  { display: '15 minutes', value: '15' },
  { display: '20 minutes', value: '20' },
  { display: '25 minutes', value: '25' },
  { display: '30 minutes', value: '30' },
  { display: '35 minutes', value: '35' },
  { display: '40 minutes', value: '40' },
  { display: '45 minutes', value: '45' },
  { display: '50 minutes', value: '50' },
  { display: '55 minutes', value: '55' },
]

export const HOURS = [
  { display: '0 hour', value: '0' },
  { display: '1 hour', value: '1' },
  { display: '2 hours', value: '2' },
  { display: '3 hours', value: '3' },
  { display: '4 hours', value: '4' },
  { display: '5 hours', value: '5' },
  { display: '6 hours', value: '6' },
  { display: '7 hours', value: '7' },
  { display: '8 hours', value: '8' },
  { display: '9 hours', value: '9' },
  { display: '10+ hours', value: '10' },
]

export const SERVINGS = [
  { display: '1', value: '1' },
  { display: '2', value: '2' },
  { display: '3', value: '3' },
  { display: '4', value: '4' },
  { display: '5', value: '5' },
  { display: '6', value: '6' },
  { display: '7', value: '7' },
  { display: '8', value: '8' },
  { display: '9', value: '9' },
  { display: '10', value: '10' },
]